




















































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
@Component({})
export default class TongueYanse extends Vue {
  @Prop()
  private r: any;
  @Prop()
  private origin: any;
  private get thead() {
    const arr = _.cloneDeep(this.r);
    return arr[0];
  }
  private get tbody() {
    const arr = _.cloneDeep(this.r);
    return arr.slice(1);
  }
}
